/**
 * Build default column definitions for PersonalizeDataGrid from list config.
 */
function estimatePersonalizeColumnWidth(label, minWidth = 120, maxWidth = 320) {
  const text = String(label || "").trim();
  const estimated = text.length * 9 + 48;
  return Math.min(maxWidth, Math.max(minWidth, estimated));
}

export function buildListPersonalizeColumns(config = {}, extraKeys = []) {
  const {
    defaultVisibleColumns = [],
    columnLabels = {},
    columnWidths = {},
    pinnedColumns = [],
    mandatoryColumns = [],
  } = config;

  const allKeys = [
    ...new Set([
      ...defaultVisibleColumns,
      ...Object.keys(columnLabels),
      ...(Array.isArray(extraKeys) ? extraKeys : []),
    ]),
  ];

  return allKeys.map((key, index) => {
    const visibleIndex = defaultVisibleColumns.indexOf(key);
    const autoLabel = key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return {
      key,
      field: key,
      label: columnLabels[key] || autoLabel,
      width: columnWidths[key] || estimatePersonalizeColumnWidth(columnLabels[key] || autoLabel),
      visible:
        visibleIndex >= 0 ||
        (defaultVisibleColumns.length === 0 && index < 5),
      pinned: pinnedColumns.includes(key) ? "left" : undefined,
      required: mandatoryColumns.includes(key),
      order: visibleIndex >= 0 ? visibleIndex : index,
    };
  });
}
